module.exports = __webpack_public_path__ + "static/img/bj.b24b3e6.png";